import { useMemo } from 'react'
import { getProblematicElements } from '@structuralPlanningUtils'
import { useQuery } from '@tanstack/react-query'
import { useModelStore, useStiffeningStore } from '@editorStores'
import { buildGuidToLabelMap } from '@editorHooks'

/**
 * We use this hook in order to get the problems on elements. It uses react
 * query internally to asynchronously get the problems on elements because the
 * calculation could potentially take a long time (especially for large models
 * and if we add more rules).
 * @param param0
 * @returns
 */
const useLoadProblems = (
  verticalTransmissionGraph: VerticalTransmissionGraph,
  elementTypes: Record<string, ElementTypes | undefined>,
  positionGuidToWallGuid: Record<string, string>,
  guidToDomain: Record<string, Domain>,
  loadsPerElement: ElementLoad[],
  guidToElement: Record<string, ShapeObject>,
): ProblematicElements | undefined => {
  const stiffeningIntervals = useStiffeningStore(state => state.stiffeningIntervals)
  const model = useModelStore(state => state.model)

  const guidToLabel = useMemo(
    () => buildGuidToLabelMap(model, stiffeningIntervals),
    [model, stiffeningIntervals],
  )

  const { data: allProblems } = useQuery<ProblematicElements>({
    queryKey: [
      'problematicElements',
      verticalTransmissionGraph,
      elementTypes,
      positionGuidToWallGuid,
      guidToDomain,
      loadsPerElement,
      guidToElement,
      stiffeningIntervals,
      guidToLabel,
    ],
    queryFn: async () =>
      getProblematicElements(
        verticalTransmissionGraph,
        elementTypes,
        positionGuidToWallGuid,
        guidToDomain,
        loadsPerElement,
        guidToElement,
        stiffeningIntervals,
        guidToLabel,
      ),
  })

  return allProblems
}

export default useLoadProblems
